// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum InkTool {
  Pen = 0,
  Pencil = 1,
  Highlighter = 2,
  Tape = 3,
  WholeEraser = 4,
  PartialEraser = 5,
  Selection = 6,
  Laser = 7
}
